export default {
  statusTrackerHoursAfterOppClose: 72,
  closedWon: 'Closed Won',
  closedLost: 'Closed Lost',
  types: {
    sba: 'SBA',
  },
};
